import type { MenuItemNotifications } from '../../types/menu-notifications';

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const isMenuNotification = (value: unknown) => {
  if (!isObject(value)) {
    return false;
  }

  return (
    typeof value.id === 'string' &&
    typeof value.type === 'string' &&
    typeof value.title === 'string' &&
    typeof value.message === 'string'
  );
};

const isMenuItemNotifications = (value: unknown): value is MenuItemNotifications => {
  if (!isObject(value)) {
    return false;
  }

  return typeof value.menuItem === 'string' && Array.isArray(value.notifications) && value.notifications.every(isMenuNotification);
};

export function parseMenuNotificationsPayload(payload: unknown): MenuItemNotifications[] {
  if (!payload) {
    return [];
  }

  let parsedPayload = payload;

  if (typeof payload === 'string') {
    try {
      parsedPayload = JSON.parse(payload);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(parsedPayload)) {
    return [];
  }

  return parsedPayload.filter(isMenuItemNotifications);
}

export function getNotificationsForMenuItem(
  menuKey: string,
  items: MenuItemNotifications[] = [],
) {
  return items.find((n) => n.menuItem === menuKey)?.notifications ?? [];
}
